import type { DateTime } from "luxon";

import type { LocalAudioRecordingTranscriptTurnRecord } from "@/domains/dexie-db/models/audio-recording/transcripts";
import type { TranscriptArrayItem } from "@/modules/audio-recording/transcript-types";

const toISOString = (dt: DateTime | undefined | null): string | undefined => {
  if (dt && typeof dt.toISO === "function") return dt.toISO() ?? undefined;
  return undefined;
};

export type TranscriptPayload = {
  transcriptArray: TranscriptArrayItem[];
  transcriptText: string;
};

export const buildTranscriptPayload = (
  records: LocalAudioRecordingTranscriptTurnRecord[]
): TranscriptPayload => {
  if (!records.length) {
    return { transcriptArray: [], transcriptText: "" };
  }

  const transcriptArray: TranscriptArrayItem[] = records.map(record => {
    const words = record.content.words ?? [];
    const transcript = words
      .map(word => word.text)
      .filter(Boolean)
      .join(" ")
      .trim();

    // Pad the turn index so lexicographic sorting preserves turn order.
    const sortKey = `${record.transcriptTurnIndex}`.padStart(6, "0");

    return {
      sort_key: sortKey,
      transcript,
      channel: record.channel ?? 0,
      timestamp: toISOString(record.content.turnTimestamp),
    };
  });

  const transcriptText = transcriptArray
    .map(item => item.transcript)
    .filter(Boolean)
    .join(" ")
    .trim();

  return { transcriptArray, transcriptText };
};
